module.exports = __webpack_public_path__ + "img/hamilelik-dogum-sigortasi.79a48bee.svg";